export function ImgDown({ size = 16, className = "" }: { size?: number, className?: string }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 3v12" />
      <path d="M18 11l-6 6-6-6" />
      <path d="M5 21h14" />
    </svg>
  );
}
